// import { Toaster } from '@blogging/ui'
import { queryClient, QueryClientProvider } from '@ngtrvu/use-api'
import { ThemeProvider } from './components/theme-provider'

interface ProvidersProps {
  children: React.ReactNode
}

export function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        {children}
        {/* <Toaster /> */}
      </ThemeProvider>
    </QueryClientProvider>
  )
}
